import { Result } from '../../../common-models/Result';
import { HttpServiceBase } from '../../../common-services/Http/HttpServiceBase';
import { CancelErpNfeInput } from './CancelErpNfeInput';
import { CancelErpNfeOutput } from './CancelErpNfeOutput';

export class CancelErpNfeService extends HttpServiceBase {

  handle = (input: CancelErpNfeInput): Promise<Result<CancelErpNfeOutput> | null> => {
    const promise = this.http.put<Result<CancelErpNfeOutput>, CancelErpNfeInput>(
      `${this.baseUrlSislogApi}/v2/erp-nfe/${input.erpNfeId}/cancel`,
      input
    );
    return promise;
  }
}
